import { generateSkinDefaults } from '@wix/editor-elements-panel';
import { stylableButtonSkinDefinitionMap } from '../StylableButton/StylableButton.skinParams';
import { skins } from './constants';

export const searchButtonSkinDefinition = {
  [skins.searchButtonSkin]:
    stylableButtonSkinDefinitionMap['wixui.skins.StylableButton'],
};

export default generateSkinDefaults(searchButtonSkinDefinition);
